// Add a close button to the first important message / alert at top of mains site page

document.addEventListener("DOMContentLoaded", () => {
    //console.log("alert button handler loaded")
    const alertContainer = document.getElementById("alerts-container")
    if (alertContainer) {
       // console.log("found alert container")
        const firstAlert = alertContainer.querySelector(".alertitem");
        if (firstAlert) {
            //console.log("adding button")
            const extraCol = document.createElement("div")
            extraCol.setAttribute("class", "col-auto")
            const btn = document.createElement("button")
            btn.setAttribute("class", "alert-close")
            btn.setAttribute("data-bs-toggle", "collapse")
            btn.setAttribute("data-bs-target", "#alerts-container")
            btn.setAttribute("aria-expanded", "true")
            btn.setAttribute("aria-controls", "alerts-container")
            const img = document.createElement("img")
            img.setAttribute("alt", "Dismiss Alert")
            img.setAttribute("height", "14")
            img.setAttribute("width", "14")
            const danger = firstAlert.classList.contains("danger")
            img.setAttribute("src", `/img/x${danger ? "2" : ""}.svg`)
            btn.appendChild(img)
            extraCol.appendChild(btn)
            const row = firstAlert.querySelector(".row")
            row.appendChild(extraCol)
        }
    }
});